export function layoutMiddlewares(...middlewares) {
    return [...middlewares, 'layout'];
}
export function claimDeclarationMiddlewares(...middlewares) {
    if (middlewares.length === 0) {
        return ['authenticated', 'contextEntitiesFetched', 'claimFetched', 'layout'];
    }
    return ['authenticated', 'contextEntitiesFetched', 'claimFetched', ...middlewares, 'layout'];
}
